var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"driver-banner"},[_c('div',{staticClass:"page-width"},[_c('div',{staticClass:"apply"},[_c('button',{staticClass:"dialogBut",on:{"click":_vm.handleClick}},[_vm._v("申请成为美菜合作司机")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }